var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('b-tabs',[_c('b-tab',{attrs:{"title":"Attendance","lazy":""}},[_c('l-a-office-times')],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Reports","lazy":""}},[_c('l-a-reports')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }